import { Alert, AlertTitle, Box, Collapse, IconButton } from '@mui/material';
import { Close as CloseIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon } from '@mui/icons-material';
import { useState } from 'react';

interface ErrorAlertProps {
  message: string;
  title?: string;
  onClose?: () => void;
  details?: any;
  variant?: 'standard' | 'filled' | 'outlined';
  severity?: 'error' | 'warning' | 'info' | 'success';
}

export default function ErrorAlert({ 
  message, 
  title = 'Erro', 
  onClose, 
  details, 
  variant = 'standard',
  severity = 'error'
}: ErrorAlertProps) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Alert 
      severity={severity} 
      variant={variant}
      action={
        <Box display="flex" alignItems="center">
          {details && (
            <IconButton
              size="small"
              onClick={() => setShowDetails(!showDetails)}
              sx={{ mr: 1 }}
            >
              {showDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          )}
          {onClose && (
            <IconButton size="small" onClick={onClose} aria-label="Fechar">
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
      
      {details && (
        <Collapse in={showDetails}>
          <Box sx={{ mt: 1, p: 1, bgcolor: 'rgba(0,0,0,0.05)', borderRadius: 1 }}>
            <pre style={{ fontSize: '0.75rem', margin: 0, whiteSpace: 'pre-wrap' }}>
              {typeof details === 'string' ? details : JSON.stringify(details, null, 2)}
            </pre>
          </Box>
        </Collapse>
      )}
    </Alert>
  );
}
